import React from 'react';
import { motion } from 'framer-motion';

export default function BeamProgress({ name, spent, target, colorClass }) {
  const percent = Math.min(100, Math.max(0, (spent / target) * 100));
  const isOver = spent > target;
  
  // Extract base color for glow effect (simplified for demo)
  const isEmerald = colorClass.includes('emerald');
  const isAccent = colorClass.includes('accent');
  const glowColor = isOver ? 'rgba(239, 68, 68, 0.6)' : isEmerald ? 'rgba(52, 211, 153, 0.6)' : isAccent ? 'rgba(0, 240, 255, 0.6)' : 'rgba(251, 191, 36, 0.6)';

  return (
    <div className="mb-5 group">
      <div className="flex justify-between text-sm mb-2">
        <span className="text-gray-200 font-medium tracking-wide">{name}</span>
        <span className="font-mono text-xs">
          <span className={isOver ? 'text-red-400 font-bold' : 'text-white'}>${spent.toFixed(2)}</span> 
          <span className="text-gray-500 mx-1">/</span> 
          <span className="text-bb-gold">${target.toFixed(2)}</span>
        </span>
      </div>
      <div className="h-2.5 w-full bg-bb-dark rounded-full overflow-hidden border border-white/5 relative">
        {/* Background Trail */}
        <div className={`absolute top-0 left-0 h-full w-full opacity-10 bg-gradient-to-r ${colorClass}`}></div>
        
        {/* Active Beam */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percent}%` }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
          className={`h-full relative rounded-full ${isOver ? 'bg-gradient-to-r from-red-600 to-red-400' : `bg-gradient-to-r ${colorClass}`}`}
          style={{ boxShadow: `0 0 12px ${glowColor}` }}
        >
          {/* Glowing Tip */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1.5 h-4 bg-white rounded-full shadow-[0_0_10px_rgba(255,255,255,1)] blur-[0.5px]"></div>
        </motion.div>
      </div>
    </div>
  );
}